import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/common/Sidebar";

export default function MainLayout({
  children
}: {
  children?: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background">
      <div className="flex h-screen">
        <Sidebar />
        <main className="flex-1 overflow-auto">
          {/* 
            Render children if provided (when used as a wrapper component), 
            otherwise render Outlet for nested routes (when used as a layout route).
          */}
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
}
